import { DataBean } from "../../DataBean";


export class PhotoViews extends DataBean {

    public async getPersonPhotoViews(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPersonPhotoViews_Number", [args]);
    }

}